// @flow
import React from 'react';
import type { Bloc, BlocContent, Attributes, LinkAttributes } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import { convertCSS } from 'utils/convertUtils';

export type Props = {
  childrens: Array<Bloc | BlocContent>,
  attributes: Array<Attributes>,
  tagName: string
};

export const Component = (props: Props) => {
  if (props.tagName === 'a') {
    const attr = renderLinkAttributes(props.attributes);
    return <a {...attr}>{renderElement(props)}</a>;
  }
  return <props.tagName {...renderAttributes(props.attributes)}>{renderElement(props)}</props.tagName>;
};

const renderElement = (props: Props) => {
  if (props.childrens) {
    return props.childrens.map((c: Bloc | BlocContent, index) => {
      if (c.type === 'text' && c.text) return c.text;
      else if (c.attributes) return <ContentBloc {...c} key={index} />;
      else return null;
    });
  }
  return null;
};

const renderAttributes = (attributes: Array<Attributes>) => {
  if (attributes.length > 0) {
    return attributes.reduce((acc, obj) => {
      if (obj.name === 'class' || obj.name === 'classname') {
        acc['className'] = obj.value;
      } else if (obj.name === 'stroke-width') {
        acc['strokeWidth'] = obj.value;
      } else if (obj.name === 'fill-rule') {
        acc['fillRule'] = obj.value;
      } else if (obj.name === 'datetime') {
        acc['dateTime'] = obj.value;
      } else if (obj.name === 'srcset') {
        acc['srcSet'] = obj.value;
      } else if (obj.name === 'frameborder') {
        acc['frameBorder'] = obj.value;
      } else if (obj.name === 'allowfullscreen') {
        acc['allowFullScreen'] = obj.value;
      } else if (obj.name === 'style') {
        acc[obj.name] = convertCSS(obj.value);
      } else if (obj.name === 'controls') {
				acc['controls'] = true;
			} else {
        acc[obj.name] = obj.value;
      }
      return { ...acc };
    }, {});
  }
  return null;
};

const renderLinkAttributes = (attributes: Array<Attributes>): LinkAttributes => {
  if (attributes.length > 0) {
    const attrObject = attributes.reduce((acc, obj): LinkAttributes => {
      if (obj.name === 'class' || obj.name === 'classname') {
        acc['className'] = obj.value;
      } else if (obj.name === 'href') {
        acc['href'] = obj.value;
      } else if (obj.name === 'style') {
        acc[obj.name] = convertCSS(obj.value);
      } else {
        acc[obj.name] = obj.value;
      }
      return { ...acc };
    }, {});
    return attrObject;
  }
  return { href: '#' };
};
